export default __webpack_public_path__ + "static/media/Menu_Sport_Socks.a5cc82e2.svg";